
export class NodoArbolMenu {
  public id: string;
  public menuId: string;
  public name: string;
  public url: string;
  public descripcionMenu: string;
  public type: string;
  public parentId: string;
  public assistanceId: string;
  public codigoAsistenteAccion: string;
  public answer: string;
  public idContenido: string;
  public order: number;
  public creationDate: number;
  public updateDate: number;
  public updateUser: string;
  public level: number;
  public childs: NodoArbolMenu[];
  public faqs: { id: string, consulta: string, respuesta: string, idContenido: string, codigoTemaDestinatario: string ,idNodo:string}[];
  public path: string;
  public areaCode: string;
  public conDestinatario: boolean;
  public esFormulario: boolean;
  public idDestinatario: number;
  public tipoFormulario: string;
  public temaMotivo: string;
  public requiereAutenticacion: boolean;
  public visible: boolean;
  public idAsistente: string;
  public encoladoMaximo: number;
  public guardarHistorico: boolean;
  public requiereEncuesta: boolean;
  public codigoEncuesta:string;
  public listaValidaciones:number[];
  constructor(
    id: string,
    idMenu: string,
    nombre: string,
    url: string,
    tipoNodo: string,
    idPadre: string,
    idAsistencia: string,
    codigoAsistenteAccion: string= undefined,
    respuesta: string,
    idContenido: string,
    path: string,
    codigoTemaDestinatario: string,
    orden: number = undefined,
    fechaCreacion: number = undefined,
    fechaActualizacion: number = undefined,
    usuarioActualizacion: string = undefined,
    nivel: number = undefined,
    faqs: { id: string, consulta: string, respuesta: string, idContenido: string, codigoTemaDestinatario: string,idNodo:string }[] = undefined,
    conDestinatario: boolean = false,
    esFormulario: boolean = false,
    descripcionMenu: string = undefined,
    idDestinatario: number = undefined,
    tipoFormulario: string = undefined,
    temaMotivo: string = undefined,
    requiereAutenticacion: boolean = undefined,
    visible: boolean= true,
    idAsistente: string = undefined,
    encoladoMaximo: number = undefined,
    guardarHistorico: boolean = false,
    requiereEncuesta: boolean = false,
    codigoEncuesta: string = undefined,
    listaValidaciones:number[] = undefined
  ) {
    this.id = id;
    this.menuId = idMenu;
    this.name = nombre;
    this.url = url;
    this.type = tipoNodo;
    this.parentId = idPadre;
    this.assistanceId = idAsistencia;
    this.codigoAsistenteAccion = codigoAsistenteAccion;
    this.answer = respuesta;
    this.idContenido = idContenido;
    this.path = path;
    this.areaCode = codigoTemaDestinatario;
    this.order = orden;
    this.creationDate = fechaCreacion;
    this.updateDate = fechaActualizacion;
    this.updateUser = usuarioActualizacion;
    this.level = nivel;
    this.faqs = faqs || [];
    this.conDestinatario = conDestinatario;
    this.esFormulario = esFormulario;
    this.descripcionMenu = descripcionMenu;
    this.idDestinatario = idDestinatario;
    this.tipoFormulario = tipoFormulario;
    this.temaMotivo = temaMotivo;
    this.requiereAutenticacion = requiereAutenticacion;
    this.visible = visible;
    this.idAsistente = idAsistente || idMenu;
    this.encoladoMaximo = encoladoMaximo;
    this.guardarHistorico = guardarHistorico;
    this.requiereEncuesta = requiereEncuesta;
    this.codigoEncuesta = codigoEncuesta;
    this.listaValidaciones = listaValidaciones;
  }

  buildTree(jsonNodoMenu): NodoArbolMenu[] {
    //debugger
    if (jsonNodoMenu.childs.length == 0) {
      return [];
    }
    for (let child of jsonNodoMenu.childs) {
      //debugger
      let nodo = new NodoArbolMenu(
        child.id,
        child.idMenu,
        child.nombre,
        child.url,
        child.tipoNodo,
        child.idPadre || "ROOT",
        child.idAsistenteAccion,
        child.codigoAsistenteAccion,
        child.respuesta || null,
        child.idContenido || null,
        child.path,
        child.codigoTemaDestinatario,
        child.orden,
        child.fechaCreacion,
        child.fechaActualizacion,
        child.usuarioActualizacion,
        child.nivel,
        child.faqs,
        child.conDestinatario,
        child.esFormulario,
        child.descripcionMenu,
        child.idDestinatario,
        child.tipoFormulario,
        child.temaMotivo,
        child.requiereAutenticacion || false,
        child.visible ?? true,
        child.idAsistente,
        child.encoladoMaximo,
        child.guardarHistorico || false,
        child.requiereEncuesta || false,
        child.codigoEncuesta,
        child.listaValidaciones || []
      );
      nodo.buildTree(child)
      if (this.childs == undefined) {
        this.childs = []
      }
      this.childs.push(nodo);
    }
    return this.childs;
  }


  search(nodeId: string) {
    if (this.id === nodeId) {
      return this;
    }
    if (this.childs && this.childs.length > 0) {
      for (let child of this.childs) {
        let result = child.search(nodeId);
        if (result !== null) {
          return result;
        };
      }
    }
    return null;
  }

}
